import { useParams, Navigate } from 'react-router-dom'

export default function MainStoragePosition () {
  const { storageId } = useParams()
  return <Navigate to='/process/storage' state={{ initialStorageId: Number(storageId) }} replace />
}
